<template>
    <div>
        <!-- Modal -->
        <div class="modal fade" id="verEmpacotadosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Empacotados</h5>
                        <button type="button" class="close" @click="fechar()" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <az-empty-state v-if="!dados" />

                        <template v-else>
                            <div class="alert alert-info">
                                <div>{{ dados.procedimento.search }}</div>
                                <div>#{{ dados.id_atendimento }}</div>
                                <div>{{ $util.getFormatDate(dados.atendimento.dt_inicio) }}</div>
                                <div>{{ $util.formatMoeda(dados.cd_valor_total) }}</div>
                            </div>

                            <table class="table table-hover mb-0">
                                <thead>
                                    <tr>
                                        <th>Descrição</th>
                                        <th>Atendimento</th>
                                        <th>Data</th>
                                        <th class="text-right">Valor</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(atp, iap) in dados.empacotados" :key="iap">
                                        <td>
                                            {{ atp.procedimento.search }}
                                        </td>
                                        <td>
                                            #{{ atp.id_atendimento }}
                                            <i class="fas fa-star-of-life ml-2" v-if="atp.id_atendimento != dados.id_atendimento" title="Outro atendimento."></i>
                                        </td>
                                        <td>
                                            {{ $util.getFormatDate(atp.atendimento.dt_inicio) }}
                                        </td>
                                        <td class="text-right">
                                            {{ $util.formatMoeda(atp.cd_valor_total) }}
                                        </td>
                                    </tr>
                                </tbody>
                                <tfoot>
                                    <tr>
                                        <td colspan="3">Total</td>
                                        <td class="text-right">{{ $util.formatMoeda(total_empacotado) }}</td>
                                    </tr>
                                </tfoot>
                            </table>

                            <pre v-if="false">{{ dados }}</pre>
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar()">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzEmptyState from '../../util/AzEmptyState.vue';

export default {
    data() { 
        return { 
            dados: null, 
        };
    },

    components: { 
        AzEmptyState, 
    },

    computed: { 
        total_empacotado: function () { 
            if ( !this.dados || !this.dados.empacotados ) { 
                return 0;
            }

            return this.dados.empacotados.reduce((total, carry) => { 
                return total + parseFloat(carry.cd_valor_total);
            }, 0);
        }
    },
    
    methods: { 
        fechar () { 
            $('#verEmpacotadosModal').modal('hide');
        },

        abrir (id_atendimento_procedimento) { 
            this.dados = null;

            $('#verEmpacotadosModal').modal('show');

            this.$util.load(this, { 
                service: 'atendimentos',
                func: 'empacotados', 
                parms: { 
                    id_atendimento_procedimento: id_atendimento_procedimento, 
                },
                loadTo: res => { 
                    this.dados = res; 
                }
            })

        }
    }
}
</script>